<script lang="ts" setup>
import type { Bookmark } from '@ilteducation/annotations-types';
import { storeToRefs } from 'pinia';
import { useDisplay } from 'vuetify';
import useUiStore from '../../stores/ui';
import { GoToItem } from '../../types';
import AnnotationListItemBase from '../annotations/AnnotationListItemBase.vue';
import useMediaStore from '../../stores/media';

type Emits = {
  (e: 'goToBookmark', item: GoToItem): void;
  (e: 'edit', bookmark: Bookmark): void;
  (e: 'remove', bookmark: Bookmark): void;
};
const emit = defineEmits<Emits>();

type Props = {
  bookmark: Bookmark;
  isSaving?: boolean;
};
const props = defineProps<Props>();

const { toggleTableOfContentDrawer, toggleAnnotationsDrawer } = useUiStore();
const { smAndDown: isMobile } = useDisplay();
const { playing } = storeToRefs(useMediaStore());

const goToBookmark = () => {
  if (isMobile.value) {
    setTimeout(() => toggleTableOfContentDrawer(false), 300);
    setTimeout(() => toggleAnnotationsDrawer(false), 300);
  }
  const item: GoToItem = { target: props.bookmark.position, isGoingForwardsInBook: true };
  playing.value = false;

  emit('goToBookmark', item);
};
</script>

<template>
  <div>
    <AnnotationListItemBase
      :is-saving="isSaving"
      :data-testid="`bp-bookmark-item-${bookmark.id}`"
      @navigate="goToBookmark"
      @edit="emit('edit', bookmark)"
      @remove="emit('remove', bookmark)"
    >
      <v-list-item-title>{{ bookmark.name }}</v-list-item-title>
      <v-list-item-subtitle v-if="bookmark.comment?.type === 'text'">
        {{ bookmark.comment.content }}
      </v-list-item-subtitle>
    </AnnotationListItemBase>
  </div>
</template>

<style scoped lang="scss"></style>
